<template>
  <div class="subscription-price">
    <div class="plan-price">
      <span v-if="props.plan.price">
        <span class="currency">$</span>
        <span class="price-whole">{{ Math.floor(props.plan.price) }}</span>
        <span v-if="props.plan.price % 1" class="price-decimal">{{ (props.plan.price % 1).toFixed(2).substring(2) }}</span>
        <span class="plan-interval">/month</span>
      </span>
      <span v-else>Free</span>
    </div>
    <div v-if="props.plan.termMonths" class="plan-term">
      ${{ termPriceRef }} for {{ props.plan.termMonths }} months
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subscription-price {
  height: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem;
  align-items: center;
  line-height: 1.3;
}

.plan-price {
  font-size: 2.5rem;

  .currency, .price-decimal {
    font-size: 1.2rem;
    vertical-align: 50%;
  }

  .plan-interval {
    font-size: 0.875rem;
  }
}

.plan-term {
  font-size: 0.875rem;
  color: #888;
}
</style>

<script lang="ts" setup>
import { computed } from 'vue'
import { SubscriptionPlan } from '@/gp/GroupAdminModel'

const props = defineProps<{
    plan: SubscriptionPlan
}>()

const termPriceRef = computed(() => ((props.plan.price ?? 0) * (props.plan.termMonths ?? 12)).toFixed(2))
</script>